module.exports = __webpack_public_path__ + "img/qrcode.6cfc5220.png";